var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightAngleBottomLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00001 88C2.23858 88 0 85.7614 0 83L0 5.92129C0 1.47268 5.37349 -0.760843 8.52685 2.37707L47.9023 41.5597L85.6245 79.4734C88.7621 82.6269 86.5285 88 82.08 88H5.00001Z",
    fill: "#5F5F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightAngleBottomLeft);
export default __webpack_public_path__ + "static/media/RightAngle_BottomLeft.b90feb7fd60ac9b4c333868938946ba6.svg";
export { ForwardRef as ReactComponent };